import BaseValidator from 'services/validations/base-validator';
import Const from 'const';

class AtLeastOneLineOrPPGroupWasChosenForEachTeamInEachStackValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;
        const activeTeamsOfPrimaryStack = stacking.getActiveTeamsByStackNumber(Const.NHL_TEAM_STACKING_FIRST_STACK);
        const activeTeamsOfSecondaryStack = stacking.getActiveTeamsByStackNumber(Const.NHL_TEAM_STACKING_SECOND_STACK);
        const activeTeamsOfThirdStack = stacking.getActiveTeamsByStackNumber(Const.NHL_TEAM_STACKING_THIRD_STACK);

        const isCheckedAtLeastOneInAllEnabledTeamsPrimaryStack =
            this.isCheckedAtLeastOneInAllEnabledTeamsLineGroups(activeTeamsOfPrimaryStack);
        const isCheckedAtLeastOneInAllEnabledTeamsSecondaryStack =
            this.isCheckedAtLeastOneInAllEnabledTeamsLineGroups(activeTeamsOfSecondaryStack);
        const isCheckedAtLeastOneInAllEnabledTeamsThirdStack =
            this.isCheckedAtLeastOneInAllEnabledTeamsLineGroups(activeTeamsOfThirdStack);

        if (
            !isCheckedAtLeastOneInAllEnabledTeamsPrimaryStack ||
            !isCheckedAtLeastOneInAllEnabledTeamsSecondaryStack ||
            !isCheckedAtLeastOneInAllEnabledTeamsThirdStack
        ) {
            this.addError('Should be at least one Line Group or PP Line chosen for each enabled Team in each Stack.');
        }
    }

    private isCheckedAtLeastOneInAllEnabledTeamsLineGroups(activeTeams): boolean {
        for (let activeTeam of Object.values(activeTeams)) {
            // @ts-ignore
            if (activeTeam.checked === true) {
                if (
                    !this.isCheckedAtLeastOneLineGroupInTeam(activeTeam) &&
                    !this.isCheckedAtLeastOnePPLineInTeam(activeTeam)
                ) {
                    return false;
                }
            }
        }
        return true;
    }

    private isCheckedAtLeastOneLineGroupInTeam(team): boolean {
        for (let lineupGroupValue of Object.values(team.lineGroups)) {
            if (lineupGroupValue === true) {
                return true;
            }
        }
        return false;
    }

    private isCheckedAtLeastOnePPLineInTeam(team): boolean {
        for (let ppLineValue of Object.values(team.ppLines)) {
            if (ppLineValue === true) {
                return true;
            }
        }
        return false;
    }
}

export default AtLeastOneLineOrPPGroupWasChosenForEachTeamInEachStackValidator;
